import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Sentry } from '@martha-v5/sentry/browser';

export default function NotFoundPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    Sentry.captureMessage(`404 Not Found: ${pathname}`, {
      level: 'warning',
      tags: { type: 'broken-url', route: '404' },
      extra: { pathname, referrer: document.referrer },
    });
  }, [pathname]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className="w-12 h-12 rounded-xl bg-neutral-100 text-neutral-400 flex items-center justify-center mb-4">
        <FileQuestion size={24} />
      </div>
      <h1 className="text-lg font-semibold text-neutral-800 mb-1">Page not found</h1>
      <p className="text-sm text-neutral-500 mb-1">
        Nothing at <code className="text-xs bg-neutral-100 px-1.5 py-0.5 rounded font-mono">{pathname}</code>
      </p>
      <Link
        to="/"
        className="mt-4 text-sm font-medium text-coral-600 hover:text-coral-700 transition-colors"
      >
        Go home
      </Link>
    </div>
  );
}
